import '@popperjs/core';
import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;
import {Modal} from 'bootstrap';
import 'slick-carousel';
import aos
    from "aos";

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    cache: true
});

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    scroll: function (e) {
        $('html').animate({
            scrollTop: (e.offset().top - 100)
        }, "slow");
    },
    card: {
        animate: function () {
            $('.card-animate').on('mouseover', function () {
                $(this).addClass('animate__pulse');
            }).on('mouseout', function () {
                $(this).removeClass('animate__pulse');
            });
        }
    },
    viewable: function (e) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = $(e).offset().top;
        let elemBottom = elemTop + $(e).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    modal: {
        defaults: {
            closeable: false,
            icon: 'fa fa-info',
            title: {
                text: 'Info',
                color: 'text-white'
            },
            size: 'modal-lg',
            state: 'bg-info',
            resize: false,
            class: null,
            border: null,
            submitButtonClass: 'btn-success',
            cancelButtonClass: 'btn-secondary'
        },
        loading: function (selector) {
            selector = (selector === undefined ? $('#ModalWindowBody') : selector);
            let HTML = '<div class="text-center" style="width: 100%; margin: auto; padding: 15%;"><i class="fa fa-spinner fa-pulse fa-fw fa-5x text-primary"></i><div style="font-size: 36px;">LOADING...</div></div>';
            selector.html(HTML);
        },
        open: function (options) {
            let Deferred = new $.Deferred();
            options = {
                closeable: (options.closeable !== undefined ? options.closeable : utility.modal.defaults.closeable),
                icon: (options.icon !== undefined ? options.icon : utility.modal.defaults.icon),
                title: {
                    text: (options.title.text !== undefined ? options.title.text : utility.modal.defaults.title.text),
                    color: (options.title.color !== undefined ? options.title.color : utility.modal.defaults.title.color),
                },
                size: (options.size !== undefined ? options.size : utility.modal.defaults.size),
                state: (options.state !== undefined ? options.state : utility.modal.defaults.state),
                resize: (options.resize !== undefined ? options.resize : utility.modal.defaults.resize),
                class: (options.class !== undefined ? options.class : utility.modal.defaults.class),
                border: (options.border !== undefined ? options.border : utility.modal.defaults.border),
                submitButtonClass: (options.submitButtonClass !== undefined ? options.submitButtonClass : utility.modal.defaults.submitButtonClass),
                cancelButtonClass: (options.cancelButtonClass !== undefined ? options.cancelButtonClass : utility.modal.defaults.cancelButtonClass),
            };
            $('#ModalWindowWrapper').load('/actions/modal/modal/open', {}, function () {
                let $ModalWindowBody = $('#ModalWindowBody');
                $('#ModalWindowDialog').addClass(options.size);
                $('#ModalWindowIcon').addClass(options.icon).addClass(options.title.color);
                $('#ModalWindowTitle').html(options.title.text).addClass(options.title.color);
                if (options.closeable === false) {
                    $('#ModalWindowCloseButton').hide();
                }
                $('#ModalWindowHeader').addClass(options.state);
                $('#ModalWindowHeader, #ModalWindowBody, #ModalWindowFooter').addClass(options.class);
                $('#ModalWindowHeader, #ModalWindowFooter').addClass(options.border);
                $('#ModalWindowSaveButton').addClass(options.submitButtonClass);
                $('#ModalWindowCancelButton').addClass(options.cancelButtonClass).on('click', function () {
                    $('#ModalWindowCloseButton').trigger('click');
                });
                let ModalWindow = document.getElementById('ModalWindow');
                let $Modal = new Modal(ModalWindow, {
                    backdrop: 'static',
                    keyboard: false
                });
                $Modal.show();
                ModalWindow.addEventListener('hidden.bs.modal', function () {
                    $(this).remove();
                });
                if (options.resize === true) {
                    $ModalWindowBody.on('DOMSubtreeModified', function () {
                        utility.modal.resize($(this));
                    });
                }
                Deferred.resolve($ModalWindowBody);
            });
            return Deferred.promise();
        },
        resize: function ($Element) {
            let ModalHeaderFooterHeight = $('#ModalWindowHeader').outerHeight() + $('#ModalWindowFooter').outerHeight();
            let y = Math.round(($(window).innerHeight() - ModalHeaderFooterHeight) / 1.4);
            $Element.height(y);
            return false;
        },
        scroll: function (selector, offset) {
            let Deferred = new $.Deferred();
            offset = (offset === undefined ? ($('#ModalWindowHeader').height() + 60) : 0);
            $('#ModalWindowBody').animate({
                scrollTop: (selector.offset().top - offset) + $(this).scrollTop()
            }, "slow", function () {
                Deferred.resolve(false);
            });
            return Deferred.promise();
        },
        video: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa fa-video',
                title: {
                    text: $(selector).attr('data-title'),
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg'
            };
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowBody').load('/modal/video', function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        $('#ModalVideoSource').attr('src', $(selector).attr('data-target'));
                        Deferred.resolve(false);
                    });
                });
                $('#ModalWindowSaveButton').remove();
                return Deferred.promise();
            });
        },
        content: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa',
                title: {
                    text: null,
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg',
                closeable: true
            };
            let url = $(selector).prop('href');
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowSaveButton, #ModalWindowIcon').remove();
                $('#ModalWindowBody').load(url, function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        let img = '<img src="' + $('#ContentIcon').val() + '" style="height: 32px; width: auto;" alt="img"/>';
                        $('#ModalWindowTitle').html(img);
                        Deferred.resolve(false);
                    });
                }).css({
                    height: '70vh',
                    overflow: 'auto'
                });
                return Deferred.promise();
            });
        }
    }
};

let hp = {
    init: function () {
        aos.init();
        let c = hp.cookie.get('HideAlert');
        let $SiteAlert = $('#SiteAlert');
        if ($SiteAlert.length > 0 && c !== 'true') {
            $SiteAlert.fadeIn();
        }
        $('.alert-dismiss').on('click', function () {
            document.cookie = 'HideAlert=true;path=/';
        });
        let $HeroVideo = $('#HeroVideo');
        if ($HeroVideo.length > 0) {
            document.getElementById('HeroVideo').play();
        }
        if ($('#CareersDivisionForm').length > 0) {
            hp.careers.init();
        }
        if ($('#TankInfoForm').length > 0) {
            hp.resources.tank.init();
        }
        if ($('#LocationSearchForm').length > 0) {
            hp.resources.location.init();
        }
        if ($('.card-animate').length > 0) {
            utility.card.animate();
        }
        $('.btn-review-read').on('click', function () {
            let i = $(this).index('.btn-review-read');
            let $ReviewContent = $('.review-content');
            if ($ReviewContent.eq(i).css('height') === '100px') {
                $ReviewContent.eq(i).css('height', '250px');
                $(this).text('Collapse');
            } else {
                $ReviewContent.eq(i).css('height', '100px');
                $(this).text('Expand');
            }
        });
    },
    careers: {
        init: function () {
            $('#CareersDivisionForm').on('submit', function (e) {
                e.preventDefault();
                window.location = '/careers/?division=' + $('#CareersDivisionSelector').val() + '&location=' + $('#CareersLocationSelector').val();
            });
            if (window.location.search.length) {
                utility.scroll($('#CareersDivisionForm'));
            }
        }
    },
    resources: {
        location: {
            init: function () {
                let form = document.getElementById('LocationSearchForm');
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    if (form.checkValidity() === false) {
                        e.stopPropagation();
                    } else {
                        let $SubmitButton = $('#LocationSubmitButton');
                        let ButtonText = $SubmitButton.html();
                        $SubmitButton.attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
                        $.ajax('/actions/form/form/location', {
                            type: 'POST',
                            dataType: 'JSON',
                            data: $('#LocationSearchForm').serialize()
                        }).done(function (Response) {
                            $SubmitButton.removeAttr('disabled').html(ButtonText);
                            let branchId = 0;
                            let found = false;
                            $('.location-card').each(function () {
                                branchId = parseInt($(this).attr('data-branchId'));
                                $(this).hide();
                                if ($.inArray(branchId, Response.branchIds) >= 0) {
                                    $(this).show();
                                    found = true;
                                }
                            });
                            if (found === false) {
                                let $NoLocationsAlert = $('#NoLocationsAlert');
                                $NoLocationsAlert.show();
                                utility.scroll($NoLocationsAlert);
                            } else {
                                $('#NoLocationsAlert').hide();
                                utility.scroll($('#LocationsWrapper'));
                            }
                            form.classList.remove('was-validated');
                            gtag('event', 'Click', {
                                'event_category': 'Location Search',
                                'event_label': $('#LocationZipCode').val()
                            });
                        });
                    }
                    form.classList.add('was-validated');
                });
            }
        },
        btu: {
            init: function () {
                $('#InputBTU').on('focus', function () {
                    $(this).select();
                });
                let form = document.getElementById('CalculatorBTU');
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    if (form.checkValidity() === false) {
                        e.stopPropagation();
                    } else {
                        let $SubmitButton = $('CalculatorSubmitButton');
                        let ButtonText = $SubmitButton.innerText;
                        $SubmitButton.attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
                        $.ajax('', {
                            type: 'POST',
                            dataType: 'JSON',
                            data: $('#CalculatorBTU').serialize()
                        }).done(function (Response) {
                            $SubmitButton.removeAttr('disabled').html(ButtonText);
                            $('#GallonsPerHour').html(Response.GallonsPerHour.toLocaleString('en-US'));
                            $('#GallonsPerDay').html(Response.GallonsPerDay.toLocaleString('en-US'));
                            $('#GallonsPerMonth').html(Response.GallonsPerMonth.toLocaleString('en-US'));
                            $('#GallonsPerYear').html(Response.GallonsPerYear.toLocaleString('en-US'));
                            form.classList.remove('was-validated');
                        });
                    }
                    form.classList.add('was-validated');
                });
                $('#CalculatorSubmitButton').trigger('click');
            }
        },
        tank: {
            data: null,
            options: {
                width: 320,
                height: 320,
                redFrom: 0,
                redTo: 20,
                yellowFrom: 20,
                yellowTo: 40,
                greenFrom: 40,
                greenTo: 100,
                majorTicks: ['0%', '25%', '50%', '75%', '100%'],
                minorTicks: 5,
                max: 100,
                animation: {
                    startup: true,
                    duration: 2000,
                    easing: 'inAndOut'
                },
            },
            chart: null,
            level: 0,
            cta: {
                color: 'success',
                message: "Your tank level is looking good."
            },
            init: function () {
                $.getScript('https://www.gstatic.com/charts/loader.js').done(function () {
                    google.charts.load('current', {'packages': ['gauge']});
                    google.charts.setOnLoadCallback(hp.resources.tank.gauge);
                    hp.resources.tank.level = 0;
                });
                let form = document.getElementById('TankInfoForm');
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    if (form.checkValidity() === false) {
                        e.stopPropagation();
                    } else {
                        hp.resources.tank.submit('TankInfoForm')
                    }
                    form.classList.add('was-validated');
                });
            },
            gauge: function () {
                hp.resources.tank.data = google.visualization.arrayToDataTable([
                    ['Label', 'Value'],
                    ['Level', hp.resources.tank.level]
                ]);
                hp.resources.tank.chart = new google.visualization.Gauge(document.getElementById('TankLevel'));
                hp.resources.tank.chart.draw(hp.resources.tank.data, hp.resources.tank.options);
            },
            submit: function (FormID) {
                let Deferred = new $.Deferred();
                let $SubmitButton = $('#TankInfoSubmitButton');
                let $SubmitButtonText = $SubmitButton.html();
                let $TankCTA = $('#TankCTA');
                let $TankCTAButton = $('#TankCTAButton');
                let $TankCTAText = $('#TankCTAText');
                let $TankCTAAlert = $('#TankCTAAlert');
                $TankCTA.fadeOut();
                $TankCTAButton.removeClass('btn-' + hp.resources.tank.cta.color);
                $TankCTAAlert.removeClass('alert-' + hp.resources.tank.cta.color);
                $TankCTAText.html('');
                $SubmitButton.attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
                $.ajax('', {
                    type: 'POST',
                    dataType: 'JSON',
                    data: $('#' + FormID).serialize()
                }).done(function (Response) {
                    $.when($('#TankData').html(Response.HTML)).done(function () {
                        $.when($('#TankData').html(Response.HTML)).done(function () {
                            if (typeof Response.Data.LastLevel !== 'undefined') {
                                let level = (Response.Data.LastLevel * 100);
                                hp.resources.tank.level = (level + 20 > 100 ? 100 : level + 20);
                                hp.resources.tank.cta.message = "Approximately " + Math.round(Response.Data.HoursToEmpty / 24) + " Days of Fuel Remaining";
                                if (hp.resources.tank.level >= 40) {
                                    hp.resources.tank.cta.color = 'success';
                                }
                                if (hp.resources.tank.level < 40) {
                                    hp.resources.tank.cta.color = 'warning';
                                }
                                if (hp.resources.tank.level < 20) {
                                    hp.resources.tank.cta.color = 'danger';
                                }
                                $TankCTA.fadeIn();
                                $TankCTAAlert.addClass('alert-' + hp.resources.tank.cta.color);
                                if (hp.resources.tank.level < 20) {
                                    $TankCTAButton.show();
                                }
                                $TankCTAButton.addClass('btn-' + hp.resources.tank.cta.color);
                                $TankCTAText.html(hp.resources.tank.cta.message);
                            } else {
                                hp.resources.tank.level = 0;
                            }
                            hp.resources.tank.data.setValue(0, 1, hp.resources.tank.level);
                            hp.resources.tank.chart.draw(hp.resources.tank.data, hp.resources.tank.options);
                            Deferred.resolve(false);
                            $SubmitButton.removeAttr('disabled').html($SubmitButtonText);
                        });
                    });
                });
                return Deferred.promise();
            }
        }
    },
    form: {
        init: function (FormID) {
            if ($('#EventCategory').val() !== 'Request a Service Call') {
                $('#ContactLocation').on('change', function () {
                    let services = $(this).find(':selected').attr('data-services').split(',');
                    let counties = $(this).find(':selected').attr('data-counties').split(',');
                    let $ServiceItem = null;
                    $('#ServiceName > option').show().each(function () {
                        $ServiceItem = $(this);
                        if ($.inArray($ServiceItem.val(), services) === -1) {
                            $ServiceItem.hide();
                        }
                    });
                    let countyString = "";
                    $.each(counties, function (i, v) {
                        countyString += ((i + 1) === counties.length && counties.length > 1 ? " & " : (i > 0 ? ", " : "")) + v;
                    });
                    $('#LocationHelp').html('Servicing ' + countyString + ' Counties');
                });
            }
            $('#ContactInfoEdit').on('show.bs.collapse', function () {
                $('#ContactInfoReadOnly').removeClass('show');
            });
            let $ServiceBillingSame = $('#ServiceBillingSame');
            let $ContactBillingAddress = $('#ContactBillingAddress');
            let $ContactBillingCity = $('#ContactBillingCity');
            let $ContactBillingState = $('#ContactBillingState');
            let $ContactBillingZip = $('#ContactBillingZip');
            let $BillingAddressWrapper = $('#BillingAddressWrapper');
            let $ContactServiceAddress = $('#ContactServiceAddress');
            if ($ContactBillingAddress.length && $ContactBillingAddress.val().length > 0 && $ContactBillingAddress.val() === $ContactServiceAddress.val()) {
                $ServiceBillingSame.prop('checked', 'checked');
                $BillingAddressWrapper.slideUp();
            }
            $ServiceBillingSame.on('change', function () {
                if ($(this).prop('checked')) {
                    $ContactBillingAddress.val($('#ContactServiceAddress').val());
                    $ContactBillingCity.val($('#ContactServiceCity').val());
                    $ContactBillingState.val($('#ContactServiceState').val());
                    $ContactBillingZip.val($('#ContactServiceZip').val());
                    $BillingAddressWrapper.slideUp();
                } else {
                    $ContactBillingAddress.val('');
                    $ContactBillingCity.val('');
                    $ContactBillingState.val('TX');
                    $ContactBillingZip.val('');
                    $BillingAddressWrapper.slideDown();
                }
            });
            let form = document.getElementById(FormID);
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                let grv = hp.recaptcha.validate();
                let $GoogleRecaptcha = $('#GoogleRecaptcha');
                if (form.checkValidity() === false || grv === false) {
                    event.stopPropagation();
                    if (grv === false) {
                        $GoogleRecaptcha.addClass('border border-danger');
                        utility.scroll($GoogleRecaptcha);
                    }
                    utility.scroll($('.form-control:invalid, .form-check-input:invalid, .form-select:invalid').eq(0));
                } else {
                    hp.form.submit(FormID);
                }
                if (grv === true) {
                    $GoogleRecaptcha.removeClass('border border-danger');
                }
                form.classList.add('was-validated');
            }, false);
        },
        submit: function (FormID) {
            let Deferred = new $.Deferred();
            $('.btn-submit').attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
            $.ajax('', {
                type: 'POST',
                dataType: 'JSON',
                data: $('#' + FormID).serialize()
            }).done(function (Response) {
                $('.btn-submit').removeAttr('disabled').html('Done!');
                let Options = {
                    icon: 'fa fa-info-circle',
                    title: {
                        text: 'Thank You, ' + Response.Data.Contact.FirstName,
                        color: 'text-white'
                    },
                    state: 'bg-primary',
                    size: 'modal-lg'
                };
                $.when(utility.modal.open(Options)).done(function () {
                    hp.form.conversion(Response);
                    $('#ModalWindowSaveButton').remove();
                    $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                        $('#ModalWindowCancelButton').on('click', function () {
                            window.location = '/';
                        });
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        },
        conversion: function (Response) {
            if (Response.Data.SendMail.ErrorCode === 0) {
                let $ServiceName = $('#ServiceName');
                let $ContactLocation = $('#ContactLocation');
                let $EventCategory = $('#EventCategory').val();
                let $EventLabel = ($ServiceName.length > 0 ? $ServiceName.val() : $ContactLocation.length > 0 ? $ContactLocation.val() : null);
                $('#AnalyticsCategory').val($EventCategory);
                $('#AnalyticsLabel').val($EventLabel);
                gtag('event', 'generate_lead', {
                    'event_category': $EventCategory,
                    'event_label': $EventLabel
                });
                fbq('track', 'Lead');
            }
            return false;
        }
    },
    recaptcha: {
        load: function () {
            let $Deferred = $.Deferred();
            if ($('#GoogleRecaptcha').length > 0) {
                $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function () {
                    let t = setInterval(function () {
                        if (typeof grecaptcha.render === 'function') {
                            clearInterval(t);
                            grecaptcha.render('GoogleRecaptcha', {
                                'sitekey': $('#GCKey').val()
                            });
                            $Deferred.resolve(true);
                        }
                    }, 100);
                });
            } else {
                $Deferred.resolve(true);
            }
            return $Deferred.promise();
        },
        validate: function () {
            let Response = true;
            if ($('#GoogleRecaptcha').length > 0) {
                let r = grecaptcha.getResponse()
                if (r.length === 0) {
                    Response = false;
                }
            }
            return Response;
        }
    },
    contact: {
        init: function () {
            $.when(hp.recaptcha.load()).done(function () {
                hp.form.init('ContactUsForm');
            });
        }
    },
    contest: {
        init: function () {
            $.when(hp.recaptcha.load()).done(function () {
                hp.form.init('ContestForm');
            });
        }
    },
    staff: {
        bio: function (i) {
            let $Deferred = $.Deferred();
            let Options = {
                icon: 'fa fa-user',
                closeable: true,
                title: {
                    text: $('.member-name').eq(i).html(),
                    color: 'text-white'
                },
                state: 'bg-primary',
                size: ''
            };
            $.when(utility.modal.open(Options)).done(function () {
                let $HTML = $('.member-card').eq(i).clone();
                $HTML.removeClass('card shadow');
                $HTML.find('.member-bio').removeClass('d-none');
                $HTML.find('.member-card-body').removeClass('card-body');
                $HTML.removeClass('h-100').addClass('text-center');
                $HTML.find('.member-locations').remove();
                $HTML.find('.member-name').html($HTML.find('.member-title').html());
                $HTML.find('.member-title').remove();
                $HTML.find('.member-img').removeClass('card-img-top rounded-top').addClass('img-fluid rounded d-none d-lg-block mx-auto').css({
                    height: '300px',
                    width: 'auto'
                });
                $('#ModalWindowSaveButton').remove();
                $.when($('#ModalWindowBody').html($HTML)).done(function () {
                    $Deferred.resolve(false);
                });
            });
            return $Deferred.promise();
        }
    },
    image: {
        zoom: function (ElementID) {
            let $Deferred = $.Deferred();
            let $Image = $(ElementID).find('img').clone();
            $Image.removeClass('img-thumbnail');
            let Title = $Image.attr('alt');
            let Options = {
                icon: 'fa fa-image',
                closeable: true,
                title: {
                    text: Title,
                    color: 'text-white'
                },
                state: 'bg-primary',
                size: 'modal-xl'
            };
            $.when(utility.modal.open(Options)).done(function () {
                let $ModalWindowBody = $('#ModalWindowBody');
                $ModalWindowBody.addClass('text-center');
                $('#ModalWindowSaveButton').remove();
                $.when($ModalWindowBody.html($Image)).done(function () {
                    $Deferred.resolve(false);
                });
            });
        }
    },
    cookie: {
        get: function (name) {
            let cookie = {};
            document.cookie.split(';').forEach(function (el) {
                let [k, v] = el.split('=');
                cookie[k.trim()] = v;
            });
            return cookie[name];
        }
    }
}

$(function () {
        hp.init();
        if ($('#ContactUsForm').length > 0) {
            hp.contact.init();
        }
        if ($('#ContestForm').length > 0) {
            hp.contest.init();
        }

        $('.member-info').on('click', function (e) {
            e.preventDefault();
            hp.staff.bio($(this).index('.member-info'));
        });
        $('.hero-down-arrow').on('click', function (e) {
            e.preventDefault();
            utility.scroll($('section').eq(0));
        });
        $('.img-zoom').on('click', function (e) {
            e.preventDefault();
            return hp.image.zoom(this);
        });
        if ($('#CalculatorBTU').length > 0) {
            hp.resources.btu.init();
        }
    }
);